import {
  Box,
  Container,
  Heading,
  // HStack,
  //   Stack,
  //   VStack,
  FormControl,
  Breadcrumb,
  BreadcrumbItem,
  Text,
  FormHelperText,
  HStack,
  useDisclosure,
  useUpdateEffect,
  useToast,
} from "@chakra-ui/react";

import { ChevronRightIcon } from "@chakra-ui/icons";

//Components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";

import { useParams, useHistory } from "react-router-dom";
import WalletTransfer from "components/WalletTransfer/WalletTransfer";
import { useCallback, useMemo, useState } from "react";
import Select from "components/Select/Select";
import Button from "components/Button/Button";
import { NumberInputWithMax } from "components/Input/NumberInput";
import toPrecision from "util/toPrecision";
import useWalletBalance from "hooks/useWalletBalance";
import SubmitPin from "components/Modals/SubmitPin";
import { useFundEarnWalletMutation } from "services/walletApi";
import getError from "util/getError";
import SuccessModal from "components/Modals/Success";

export default function Fund(props) {
  const currentPage = "Earn";

  const params = new URLSearchParams(props?.location?.search);

  const toast = useToast();
  const { coin } = useParams();
  const history = useHistory();
  const { getBalance, isLoading: isLoadingBalance } = useWalletBalance();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isSuccessOpen,
    onOpen: onSuccessOpen,
    onClose: onSuccessClose,
  } = useDisclosure();

  const [state, _set] = useState({
    coin,
    from: params.get("from") ?? "main",
    to: "earn",
  });

  const set = useCallback(
    (update) => _set((old) => ({ ...old, ...update })),
    []
  );

  const [_fundWallet, { isLoading, isError, error, isSuccess }] =
    useFundEarnWalletMutation();

  const balance = useMemo(() => getBalance(coin), [coin, getBalance]);

  console.log("balance", balance);
  const isInsufficientBalance = useMemo(
    () => state?.amount && +state?.amount > +balance,
    [state?.amount, balance]
  );

  // console.log("Transfer", state);

  const isDisabled = useMemo(
    () =>
      !(state?.coin && state?.from && state?.to && state?.amount) ||
      isInsufficientBalance ||
      isLoading,
    [state, isInsufficientBalance, isLoading]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    onOpen();
  };

  const fundWallet = () => {
    const reqData = {
      amount: +state?.amount,
      coin: state?.coin,
      pin: state?.pin,
    };
    // console.log(reqData);

    _fundWallet({ ...reqData });
  };

  const handleSuccessClose = () => {
    history.push(`/dashboard/wallet/${state?.coin}?tab=earn`);
    onSuccessClose();
  };

  useUpdateEffect(() => {
    if (isSuccess) {
      onSuccessOpen();
    }

    if (isError && error) {
      toast({
        position: "bottom-right",
        title: "Error",
        description: getError(error?.data?.error),
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  }, [isSuccess, error, isError, toast, state?.coin, onSuccessOpen]);

  return (
    <Box>
      <Sidemenu currentPage={currentPage} logoutUser={props.logout} />
      <Header />

      <Box className="cards">
        <Box
          className="page-container"
          p={["6em 0 !important", "6.5em 1.5em !important"]}
        >
          <Container
            maxW={["100%", "100%", "calc(100% - 30vw)", "calc(100% - 45vw)"]}
            m="0"
            // p="0"
          >
            <Box px={["0", "0", "0"]}>
              <Heading fontSize="3xl">Fund Earn Wallet</Heading>

              <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
                {/* <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/wallet`}>
                    Wallet
                  </BreadcrumbLink>
                </BreadcrumbItem> */}

                <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/earn/staking?coin=${coin}`}>
                    Earn
                  </BreadcrumbLink>
                </BreadcrumbItem>

                {/* <BreadcrumbItem>
                  <BreadcrumbLink to={`/dashboard/wallet/${coin}`}>
                    Transfer
                  </BreadcrumbLink>
                </BreadcrumbItem> */}

                <BreadcrumbItem isCurrentPage>
                  <BreadcrumbLink isCurrentPage href="#">
                    Fund
                  </BreadcrumbLink>
                </BreadcrumbItem>
              </Breadcrumb>
            </Box>

            <Box
              bg="white"
              mt="20px"
              p={["24px", "56px"]}
              borderRadius={[0, "16px"]}
              border="1px solid #EFF0F7"
              as="form"
              onSubmit={handleSubmit}
            >
              <Text maxW="70%" mb="22px">
                Transfer funds to your Earn wallet
              </Text>

              <WalletTransfer
                values={{ from: state?.from, to: state?.to }}
                onChange={(values) => set({ ...values })}
                mb="22px"
                _to={{ disabled: true }}
                _swap={{ disabled: true }}
              />

              <FormControl mb="22px">
                <Select
                  label="Coin"
                  placeholder="Select Coin"
                  value={state?.coin ?? ""}
                  onChange={(e) => set({ coin: e.target.value })}
                  disabled
                >
                  <option value="tbtc">tBTC</option>
                  <option value="teth">tETH</option>
                  <option value="celo">Celo</option>
                </Select>
              </FormControl>

              <FormControl>
                <Text
                  as="label"
                  d="inline-block"
                  fontSize=".85em"
                  color="#4E4B66"
                  mb="8px"
                >
                  Amount
                </Text>
                <NumberInputWithMax
                  // label="Amount"
                  isInvalid={isInsufficientBalance}
                  placeholder="Enter amount"
                  value={state?.amount ?? ""}
                  onMax={() => set({ amount: balance })}
                  onChange={(amount) => set({ amount })}
                  isLoading={isLoadingBalance}
                />

                {isInsufficientBalance && (
                  <FormHelperText color="red.400">
                    Insufficient Balance
                  </FormHelperText>
                )}

                {!isLoadingBalance && balance && (
                  <FormHelperText>
                    <HStack>
                      <Text>Available Balance:</Text>
                      <Text color="var(--primary)" fontWeight="600">
                        {toPrecision(balance, state?.coin)}
                      </Text>
                    </HStack>
                  </FormHelperText>
                )}
              </FormControl>

              <Button
                mt="48px"
                minH="64px"
                w="100%"
                type="submit"
                disabled={isDisabled}
                isLoading={isLoading}
              >
                Submit
              </Button>
            </Box>
          </Container>
        </Box>
      </Box>

      <SubmitPin
        isOpen={isOpen}
        onClose={onClose}
        closeOnSubmit
        onPin={(pin) => set({ pin })}
        onSubmit={fundWallet}
      />

      <SuccessModal
        isOpen={isSuccessOpen}
        onClose={handleSuccessClose}
        title="Success"
        message="Your earn wallet was successfully funded"
      />
    </Box>
  );
}
